import _toConsumableArray from "/Users/fafee/Work/Loginet/InternalPortal/internal-portal/portal-client/node_modules/.pnpm/@babel+runtime@7.28.4/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _createForOfIteratorHelper from "/Users/fafee/Work/Loginet/InternalPortal/internal-portal/portal-client/node_modules/.pnpm/@babel+runtime@7.28.4/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import _objectSpread from "/Users/fafee/Work/Loginet/InternalPortal/internal-portal/portal-client/node_modules/.pnpm/@babel+runtime@7.28.4/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _regenerator from "/Users/fafee/Work/Loginet/InternalPortal/internal-portal/portal-client/node_modules/.pnpm/@babel+runtime@7.28.4/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/Users/fafee/Work/Loginet/InternalPortal/internal-portal/portal-client/node_modules/.pnpm/@babel+runtime@7.28.4/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.set.js";
import "core-js/modules/es.set.difference.v2.js";
import "core-js/modules/es.set.intersection.v2.js";
import "core-js/modules/es.set.is-disjoint-from.v2.js";
import "core-js/modules/es.set.is-subset-of.v2.js";
import "core-js/modules/es.set.is-superset-of.v2.js";
import "core-js/modules/es.set.symmetric-difference.v2.js";
import "core-js/modules/es.set.union.v2.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.string.starts-with.js";
import "core-js/modules/es.string.link.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { getPathWithoutParam } from "@/utils/util";
import { mapGetters } from "vuex";
import { PRIVILEGES } from "@/utils/const";
import network from "@/utils/network";
var axios = network.createAxiosInstance();
export default {
  name: "SideMenu",
  mounted: function mounted() {
    var _this = this;
    return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      var _absenceResponse$data, _overtimeResponse$dat, absenceResponse, overtimeResponse, _t;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.p = _context.n) {
          case 0:
            // this.openedMenus = Array.from(this.openMenuKeys);
            _this.openedMenus = ["dashboard", "time", "resource", "projects", "reporting"];
            _context.p = 1;
            _context.n = 2;
            return axios.get("/v2/absence/absence-request/my-employees");
          case 2:
            absenceResponse = _context.v;
            _this.pendingRequests = ((_absenceResponse$data = absenceResponse.data) === null || _absenceResponse$data === void 0 ? void 0 : _absenceResponse$data.pagination) || [];
            _context.n = 3;
            return axios.get("/v2/enterprise/time-management/overtime/my-employees");
          case 3:
            overtimeResponse = _context.v;
            _this.overtimeRequests = (_overtimeResponse$dat = overtimeResponse.data) === null || _overtimeResponse$dat === void 0 ? void 0 : _overtimeResponse$dat.pagination;
            _context.n = 5;
            break;
          case 4:
            _context.p = 4;
            _t = _context.v;
            console.error(_t);
          case 5:
            return _context.a(2);
        }
      }, _callee, null, [[1, 4]]);
    }))();
  },
  data: function data() {
    return {
      openedMenus: [],
      dropdownRoutes: {
        absence: ["/my-absence-requests"],
        requests: ["/approval/overtime", "/approval/overtime/handle-requests", "/approval/absence", "/approval/absence/handle-requests", "/approval/schedule", "/approval/permissions"],
        settings: ["/settings/tiers", "/settings/project-dimensions", "/settings/project-base-data", "/settings/clients", "/settings/sudo", "/settings/sites", "/settings/work-schedule/sites", "/settings/permissions", "/settings/broadcast/templates", "/settings/tenants", "/controlling/logins", "/settings/admin-config", "/settings/roles", "/settings/overtime-policies"],
        projects: ["/projects/list#all", "/projects/list#simple", "/projects/list#support", "/projects/list#outsource", "/projects/list#public", "/projects/project-create"],
        ralloc: ["ralloc/utilization", "ralloc/utilization#projects", "ralloc/utilization#employees"],
        controlling: ["/controlling/dashboard", "/controlling/synopsis", "/controlling/timesheet", "/controlling/query", "/controlling/project-aggregation", "/controlling/risk-management", "/controlling/unknown-í", "/controlling/errors", "/controlling/invoices", "/controlling/resource-management"],
        userAdmin: ["/census/management", "/census/attributes", "/settings/teams", "/settings/team", "/census/schedules", "/census/admin/work-schedule", "/census/seatings", "/controlling/seating", "/controlling/seating-availability"],
        absenceAdmin: ["/absence/admin/requests", "/absence/admin/create", "/absence/admin/special-days", "/absence/admin/quotas", "/absence/admin/quota", "/absence/types", "/absence/admin/reports"],
        forecast: ["/forecast/chance-category", "/forecast/scenario", "/forecast/segment", "/forecast/plan", "/forecast/fact", "/forecast/dashboard"],
        reporting: ["/reports/timesheet", "/reports/query"]
      },
      pendingRequests: null,
      overtimeRequests: null
    };
  },
  computed: _objectSpread(_objectSpread({}, mapGetters({
    displayName: "session/displayName",
    occupation: "session/occupation",
    avatar: "session/avatar",
    env: "env/getField"
  })), {}, {
    tenantBadge: function tenantBadge() {
      return this.env("TENANT_BADGE");
    },
    environment: function environment() {
      return this.env("ENVIRONMENT_BADGE");
    },
    version: function version() {
      var _this$env;
      return (_this$env = this.env("CLIENT_VERSION")) === null || _this$env === void 0 ? void 0 : _this$env.replace(/.+/g, "v$&");
    },
    pendingRequestsCount: function pendingRequestsCount() {
      var _this$pendingRequests, _this$overtimeRequest;
      return (((_this$pendingRequests = this.pendingRequests) === null || _this$pendingRequests === void 0 ? void 0 : _this$pendingRequests.totalPendingCount) || 0) + (((_this$overtimeRequest = this.overtimeRequests) === null || _this$overtimeRequest === void 0 ? void 0 : _this$overtimeRequest.totalPendingCount) || 0);
    },
    hasRequestsAnyActiveItem: function hasRequestsAnyActiveItem() {
      return this.dropdownRoutes.requests.includes(getPathWithoutParam(this.$route));
    },
    hasProjectsAnyActiveItem: function hasProjectsAnyActiveItem() {
      return getPathWithoutParam(this.$route).includes("/projects");
    },
    hasRallocAnyActiveItem: function hasRallocAnyActiveItem() {
      return getPathWithoutParam(this.$route).includes("/ralloc");
    },
    hasControllingAnyActiveItem: function hasControllingAnyActiveItem() {
      return this.dropdownRoutes.controlling.includes(getPathWithoutParam(this.$route));
    },
    hasSettingsAnyActiveItem: function hasSettingsAnyActiveItem() {
      return this.dropdownRoutes.settings.includes(getPathWithoutParam(this.$route));
    },
    hasUserAdminAnyActiveItem: function hasUserAdminAnyActiveItem() {
      return this.dropdownRoutes.userAdmin.includes(getPathWithoutParam(this.$route));
    },
    hasAbsenceAdminAnyActiveItem: function hasAbsenceAdminAnyActiveItem() {
      return this.dropdownRoutes.absenceAdmin.includes(getPathWithoutParam(this.$route));
    },
    hasForecastAnyActiveItem: function hasForecastAnyActiveItem() {
      return this.dropdownRoutes.forecast.includes(getPathWithoutParam(this.$route));
    },
    hasReportingAnyActiveItem: function hasReportingAnyActiveItem() {
      return this.dropdownRoutes.reporting.includes(getPathWithoutParam(this.$route));
    },
    canSeeWorkSchedule: function canSeeWorkSchedule() {
      return this.$store.getters["session/hasAnyAuthority"](PRIVILEGES.CENSUS.WORKSCHEDULE.GET, PRIVILEGES.CENSUS.WORKSCHEDULE.ADMIN);
    },
    canSeeAbsenceRequests: function canSeeAbsenceRequests() {
      return this.$store.getters["session/hasAnyAuthority"](PRIVILEGES.ABSENCE.REQUEST.CREATE, PRIVILEGES.ABSENCE.REQUEST.ADMIN);
    },
    canSeeColleagues: function canSeeColleagues() {
      return this.$store.getters["session/hasAnyAuthority"](PRIVILEGES.CENSUS.MISC.LIST_COLLEAGUES, PRIVILEGES.CENSUS.MISC.ADMIN);
    },
    canSeeRequests: function canSeeRequests() {
      return this.$store.getters["session/hasAnyAuthority"](PRIVILEGES.ABSENCE.REQUEST.LIST_ASSIGNED, PRIVILEGES.ABSENCE.REQUEST.LIST_ANY, PRIVILEGES.ABSENCE.REQUEST.ADMIN, PRIVILEGES.ENTERPRISE.OVERTIME.LIST_REQUEST, PRIVILEGES.ENTERPRISE.OVERTIME.ADMIN);
    },
    canSeeControlling: function canSeeControlling() {
      return this.$store.getters["session/hasAnyAuthority"](PRIVILEGES.ENTERPRISE.MISC.LIST_OVERVIEW, PRIVILEGES.ENTERPRISE.MISC.LIST_SYNOPSYS, PRIVILEGES.ENTERPRISE.MISC.ADMIN, PRIVILEGES.ENTERPRISE.PROJECT.LIST_ASSIGNED, PRIVILEGES.ENTERPRISE.PROJECT.LIST_ANY, PRIVILEGES.ENTERPRISE.PROJECT.ADMIN, PRIVILEGES.ENTERPRISE.PROJECT_EXTRAS.ADMIN, PRIVILEGES.ENTERPRISE.TIMESHEET.GET_ASSIGNED, PRIVILEGES.ENTERPRISE.TIMESHEET.GET_ANY, PRIVILEGES.ENTERPRISE.RISK_MANAGEMENT.LIST_ASSIGNED, PRIVILEGES.ENTERPRISE.RISK_MANAGEMENT.LIST_ANY, PRIVILEGES.ENTERPRISE.RISK_MANAGEMENT.ADMIN);
    },
    canSeeResource: function canSeeResource() {
      return this.$store.getters["session/hasAnyAuthority"](PRIVILEGES.RALLOC.RESOURCE_ALLOCATION.ADMIN, PRIVILEGES.RALLOC.RESOURCE_ALLOCATION.CREATE, PRIVILEGES.RALLOC.RESOURCE_ALLOCATION.LIST, PRIVILEGES.RALLOC.RESOURCE_ALLOCATION.EDIT, PRIVILEGES.RALLOC.RESOURCE_ALLOCATION.DELETE);
    },
    canSeeSettings: function canSeeSettings() {
      return this.$store.getters["session/hasAnyAuthority"](PRIVILEGES.CENSUS.MISC.CREATE_SITE, PRIVILEGES.CENSUS.MISC.EDIT_SITE, PRIVILEGES.CENSUS.MISC.DELETE_SITE, PRIVILEGES.CENSUS.MISC.ADMIN, PRIVILEGES.ENTERPRISE.CLIENT.CREATE, PRIVILEGES.ENTERPRISE.CLIENT.EDIT, PRIVILEGES.ENTERPRISE.CLIENT.DELETE, PRIVILEGES.ENTERPRISE.CLIENT.ADMIN, PRIVILEGES.ENTERPRISE.TIER.CREATE, PRIVILEGES.ENTERPRISE.TIER.ADMIN, PRIVILEGES.ENTERPRISE.TIER.LIST_ANY, PRIVILEGES.ENTERPRISE.TIER.EDIT, PRIVILEGES.ENTERPRISE.TIER.DELETE, PRIVILEGES.ENTERPRISE.PROJECT_CATEGORIES.CREATE, PRIVILEGES.ENTERPRISE.PROJECT_CATEGORIES.EDIT, PRIVILEGES.ENTERPRISE.PROJECT_CATEGORIES.DELETE, PRIVILEGES.ENTERPRISE.PROJECT_CATEGORIES.ADMIN, PRIVILEGES.BULWARK.ROLE.LIST, PRIVILEGES.BULWARK.ROLE.ADMIN, PRIVILEGES.TENANT.CONFIG.ADMIN);
    },
    canSeeUserAdmin: function canSeeUserAdmin() {
      return this.$store.getters["session/hasAnyAuthority"](PRIVILEGES.CENSUS.USER.CREATE, PRIVILEGES.CENSUS.USER.EDIT, PRIVILEGES.CENSUS.USER.DELETE, PRIVILEGES.CENSUS.USER.ADMIN, PRIVILEGES.ENTERPRISE.TIER.LIST_ANY, PRIVILEGES.ENTERPRISE.TIER.ADMIN, PRIVILEGES.CENSUS.TEAM.CREATE, PRIVILEGES.CENSUS.TEAM.EDIT, PRIVILEGES.CENSUS.TEAM.DELETE, PRIVILEGES.CENSUS.TEAM.ADMIN, PRIVILEGES.CENSUS.WORKSCHEDULE.LIST, PRIVILEGES.CENSUS.WORKSCHEDULE.EDIT, PRIVILEGES.CENSUS.WORKSCHEDULE.ADMIN);
    },
    canSeeAbsenceAdmin: function canSeeAbsenceAdmin() {
      return this.$store.getters["session/hasAnyAuthority"](PRIVILEGES.ABSENCE.REQUEST.CREATE_ANY, PRIVILEGES.ABSENCE.REQUEST.ADMIN, PRIVILEGES.ABSENCE.SPECIAL_DAY.CREATE, PRIVILEGES.ABSENCE.SPECIAL_DAY.EDIT, PRIVILEGES.ABSENCE.SPECIAL_DAY.DELETE, PRIVILEGES.ABSENCE.SPECIAL_DAY.ADMIN, PRIVILEGES.ABSENCE.QUOTA.LIST, PRIVILEGES.ABSENCE.QUOTA.ADMIN, PRIVILEGES.ABSENCE.TYPE.CREATE, PRIVILEGES.ABSENCE.TYPE.EDIT, PRIVILEGES.ABSENCE.TYPE.DELETE, PRIVILEGES.ABSENCE.TYPE.ADMIN, PRIVILEGES.ABSENCE.MISC.EXPORT_ABSENCES, PRIVILEGES.ABSENCE.MISC.ADMIN);
    },
    canSeeForecast: function canSeeForecast() {
      return this.$store.getters["session/hasAnyAuthority"](PRIVILEGES.ENTERPRISE.FORECAST.PLAN.LIST_OWN, PRIVILEGES.ENTERPRISE.FORECAST.PLAN.LIST_ANY, PRIVILEGES.ENTERPRISE.FORECAST.FACT.LIST_OWN, PRIVILEGES.ENTERPRISE.FORECAST.FACT.LIST_ANY, PRIVILEGES.ENTERPRISE.FORECAST.SEGMENT.LIST, PRIVILEGES.ENTERPRISE.FORECAST.MISC.DASHBOARD, PRIVILEGES.ENTERPRISE.FORECAST.MISC.ADMIN);
    },
    canSeeReporting: function canSeeReporting() {
      return this.$store.getters["session/hasAnyAuthority"](PRIVILEGES.ENTERPRISE.TIMESHEET.GET_ANY, PRIVILEGES.ENTERPRISE.TIMESHEET.ADMIN, PRIVILEGES.ENTERPRISE.REPORT.GET_MONEYLESS, PRIVILEGES.ENTERPRISE.REPORT.ADMIN);
    },
    canHandleOvertimeRequests: function canHandleOvertimeRequests() {
      return this.$store.getters["session/hasAnyAuthority"](PRIVILEGES.ENTERPRISE.OVERTIME.LIST_REQUEST, PRIVILEGES.ENTERPRISE.OVERTIME.ADMIN);
    },
    canHandleAbsenceRequests: function canHandleAbsenceRequests() {
      return this.$store.getters["session/hasAnyAuthority"](PRIVILEGES.ABSENCE.REQUEST.LIST_ASSIGNED, PRIVILEGES.ABSENCE.REQUEST.LIST_ANY, PRIVILEGES.ABSENCE.REQUEST.ADMIN);
    },
    canSeeMoneylessProjects: function canSeeMoneylessProjects() {
      return this.$store.getters["session/hasAnyAuthority"](PRIVILEGES.ENTERPRISE.PROJECT.GET_PUBLIC, PRIVILEGES.ENTERPRISE.PROJECT.ADMIN);
    },
    canSeeTimesheets: function canSeeTimesheets() {
      return this.$store.getters["session/hasAnyAuthority"](PRIVILEGES.ENTERPRISE.TIMESHEET.GET_ANY, PRIVILEGES.ENTERPRISE.TIMESHEET.ADMIN);
    },
    canSeeMoneylessReport: function canSeeMoneylessReport() {
      return this.$store.getters["session/hasAnyAuthority"](PRIVILEGES.ENTERPRISE.REPORT.GET_MONEYLESS, PRIVILEGES.ENTERPRISE.REPORT.ADMIN);
    },
    canSeeExecutive: function canSeeExecutive() {
      return this.$store.getters["session/hasAnyAuthority"](PRIVILEGES.ENTERPRISE.MISC.LIST_OVERVIEW, PRIVILEGES.ENTERPRISE.MISC.ADMIN);
    },
    canSeeTeam: function canSeeTeam() {
      return this.$store.getters["session/hasAnyAuthority"](PRIVILEGES.ENTERPRISE.MISC.LIST_SYNOPSYS, PRIVILEGES.ENTERPRISE.MISC.ADMIN);
    },
    canSeeProjects: function canSeeProjects() {
      return this.$store.getters["session/hasAnyAuthority"](PRIVILEGES.ENTERPRISE.PROJECT.LIST_ASSIGNED, PRIVILEGES.ENTERPRISE.PROJECT.LIST_ANY, PRIVILEGES.ENTERPRISE.PROJECT.ADMIN);
    },
    canSeeSheets: function canSeeSheets() {
      return this.$store.getters["session/hasAnyAuthority"](PRIVILEGES.ENTERPRISE.TIMESHEET.GET_ASSIGNED, PRIVILEGES.ENTERPRISE.TIMESHEET.GET_ANY, PRIVILEGES.ENTERPRISE.TIMESHEET.ADMIN);
    },
    canSeeQuery: function canSeeQuery() {
      return this.$store.getters["session/hasAnyAuthority"](PRIVILEGES.ENTERPRISE.PROJECT.LIST_ASSIGNED, PRIVILEGES.ENTERPRISE.PROJECT.LIST_ANY, PRIVILEGES.ENTERPRISE.PROJECT.ADMIN);
    },
    canSeeProjectAggregation: function canSeeProjectAggregation() {
      return this.$store.getters["session/hasAnyAuthority"](PRIVILEGES.ENTERPRISE.PROJECT_AGGREGATION.LIST_ASSIGNED, PRIVILEGES.ENTERPRISE.PROJECT_AGGREGATION.LIST_ANY, PRIVILEGES.ENTERPRISE.PROJECT_AGGREGATION.ADMIN);
    },
    canSeeShame: function canSeeShame() {
      return this.$store.getters["session/hasAnyAuthority"](PRIVILEGES.ENTERPRISE.RISK_MANAGEMENT.LIST_ASSIGNED, PRIVILEGES.ENTERPRISE.RISK_MANAGEMENT.LIST_ANY, PRIVILEGES.ENTERPRISE.RISK_MANAGEMENT.ADMIN);
    },
    canSeeInvoices: function canSeeInvoices() {
      return this.$store.getters["session/hasAnyAuthority"](PRIVILEGES.ENTERPRISE.PROJECT_EXTRAS.ADMIN);
    },
    canSeeResourceAllocation: function canSeeResourceAllocation() {
      return this.$store.getters["session/hasAnyAuthority"](PRIVILEGES.RALLOC.RESOURCE_ALLOCATION.LIST, PRIVILEGES.RALLOC.RESOURCE_ALLOCATION.ADMIN);
    },
    canGetAbsenceReports: function canGetAbsenceReports() {
      return this.$store.getters["session/hasAnyAuthority"](PRIVILEGES.ABSENCE.MISC.EXPORT_ABSENCES, PRIVILEGES.ABSENCE.MISC.ADMIN);
    },
    canSeeFinancialDashboard: function canSeeFinancialDashboard() {
      // TODO
      return true;
    },
    canSeeResourceDashboard: function canSeeResourceDashboard() {
      // TODO
      return true;
    },
    menuItems: function menuItems() {
      return [
      // region user
      {
        icon: "fa-regular fa-gauge-high",
        label: this.$tf("sidebar.dashboard|Dashboard"),
        classList: [],
        visible: this.canSeeResource,
        key: "dashboard",
        items: [
          // {
          //   link: "/dashboard/financial",
          //   icon: "",
          //   label: this.$tf(
          //     "sidebar.dashboard.financial|Pénzügyi vezérlőpult"
          //   ),
          //   visible: this.canSeeFinancialDashboard,
          //   key: "dashboard.financial",
          // },
          // {
          //   link: "/dashboard/resource",
          //   icon: "",
          //   label: this.$tf(
          //     "sidebar.dashboard.resource|Erőforrás vezérlőpult"
          //   ),
          //   visible: this.canSeeResourceDashboard,
          //   key: "dashboard.resource",
          // },
          // {
          //   link: "/dashboard/risk-management",
          //   icon: "",
          //   label: this.$tf(
          //     "sidebar.dashboard.riskManagement|Kockázatkezelés"
          //   ),
          //   visible: this.canSeeShame,
          //   key: "dashboard.riskManagement",
          // },
          // {
          //   link: "/dashboard/my",
          //   icon: "",
          //   label: this.$tf("sidebar.dashboard.my|Saját vezérlőpult"),
          //   visible: true,
          //   key: "dashboard.my",
          // },
        ]
      }, {
        icon: "fa-regular fa-calendar",
        label: this.$tf("sidebar.time|Időkezelés"),
        classList: [],
        visible: true,
        key: "time",
        items: [{
          link: "/",
          icon: "",
          label: this.$tf("sidebar.time.overview|Áttekintés"),
          visible: true,
          key: "time.overview"
        }, {
          link: "/time-management/logging",
          icon: "",
          label: this.$tf("sidebar.time.timeLogging|Időkövetés"),
          visible: true,
          key: "time.timeLogging"
        }, {
          link: "/my-absence-requests",
          icon: "",
          label: this.$tf("sidebar.time.timeOff|Szabadságaim"),
          visible: true,
          key: "time.timeOff"
        }, {
          link: "/pending-requests",
          icon: "",
          label: this.$tf("sidebar.time.requests|Kérelmek"),
          visible: this.canSeeRequests,
          key: "time.requests"
        }]
      }, {
        icon: "fa-regular fa-users",
        label: this.$tf("sidebar.resource|Erőforrások"),
        classList: [],
        visible: this.canSeeResource,
        key: "resource",
        items: [{
          link: "/ralloc/utilization",
          icon: "",
          label: this.$tf("sidebar.resource.resourcePlanner|Erőforrás-tervezés"),
          visible: true,
          key: "resource.resourcePlanner"
        }, {
          link: "/employee-explorer",
          icon: "",
          label: this.$tf("sidebar.resource.employeeExplorer|Felhasználó-böngésző"),
          visible: true,
          key: "resource.employeeExplorer"
        }]
      }, {
        link: "/tasks",
        icon: "fa-regular  fa-stopwatch",
        label: this.$tf("sidebar.tasks|Feladatok"),
        classList: [],
        visible: this.isUsingSelftracking,
        key: "tasks"
      },
      // endregion
      // region admin
      {
        icon: "fa-regular fa-briefcase",
        label: this.$tf("sidebar.projects.menu|Projektek"),
        classList: [],
        visible: this.canSeeControlling,
        key: "projects",
        items: [{
          link: "/projects/list#all",
          icon: "",
          label: this.$tf("sidebar.projects.all|Összevont"),
          visible: this.canSeeControlling,
          key: "projects.all"
        }, {
          link: "/projects/list#simple",
          icon: "",
          label: this.$tf("sidebar.projects.normal|Hagyományos"),
          visible: this.canSeeControlling,
          key: "projects.simple"
        }, {
          link: "/projects/list#support",
          icon: "",
          label: this.$tf("sidebar.projects.support|Folyamatos"),
          visible: this.canSeeControlling,
          key: "projects.support"
        }, {
          link: "/projects/list#outsource",
          icon: "",
          label: this.$tf("sidebar.projects.outsource|Outsource"),
          visible: this.canSeeControlling,
          key: "projects.outsource"
        }, {
          link: "/projects/list#public",
          icon: "",
          label: this.$tf("sidebar.projects.moneyless|Publikus"),
          visible: this.canSeeMoneylessProjects,
          key: "projects.public"
        }]
      }, {
        icon: "",
        label: this.$tf("sidebar.controlling.menu|Felügyelet"),
        classList: [],
        visible: this.canSeeControlling,
        key: "controlling",
        items: [{
          link: "/controlling/timesheet",
          icon: "",
          label: this.$tf("sidebar.controlling.timesheets|Timesheetek"),
          visible: this.canSeeSheets,
          key: "controlling.timesheets"
        }, {
          link: "/controlling/query",
          icon: "",
          label: this.$tf("sidebar.controlling.timesheet_query|Lekérdezés"),
          visible: this.canSeeQuery,
          key: "controlling.query"
        }, {
          link: "/reporting/my-reports",
          icon: "",
          // label: this.$tf("sidebar.riporting.aggregation|Riporting"),
          label: "Riporting",
          visible: this.canSeeProjectAggregation,
          key: "controlling.aggregation"
        }, {
          link: "/controlling/risk-management",
          icon: "",
          label: this.$tf("sidebar.controlling.risk_management|Kockázatmenedzsment"),
          visible: this.canSeeShame,
          key: "controlling.shame"
        }, {
          link: "/controlling/invoices",
          icon: "",
          label: this.$tf("sidebar.controlling.invoices|Számlák"),
          visible: this.canSeeInvoices,
          key: "projects.invoices"
        }]
      }, {
        icon: "fa-regular fa-book",
        label: this.$tf("sidebar.reporting.menu|Riportok"),
        classList: [],
        visible: this.canSeeReporting,
        key: "reporting",
        items: [{
          link: "/reporting/my-reports",
          icon: "",
          label: this.$tf("sidebar.reporting.my|My reports"),
          visible: this.canSeeProjectAggregation,
          key: "reporting.my"
        }, {
          link: "/reporting/reports",
          icon: "",
          label: this.$tf("sidebar.reporting.aggregation|Report library"),
          visible: this.canSeeProjectAggregation,
          key: "reporting.aggregation"
        }]
      }, {
        icon: "",
        link: "/forecast",
        label: this.$tf("sidebar.forecast.menu|Forecast"),
        classList: ["sidebar-icon-fa"],
        visible: false,
        key: "forecast",
        items: []
      }
      // endregion
      ];
    },
    logo: function logo() {
      return process.env.VUE_APP_MENU_LOGO_CLOSED;
      // return getCurrentTheme() === UI_THEMES.DARK
      //   ? process.env.VUE_APP_MENU_LOGO_DARK
      //   : process.env.VUE_APP_MENU_LOGO;
    },
    openMenuKeys: function openMenuKeys() {
      var _this$$route$meta;
      // Use path instead of fullPath to ignore query parameters
      var currentPath = this.$route.path;
      var currentFullPath = this.$route.fullPath;
      var currentSidebarKey = (_this$$route$meta = this.$route.meta) === null || _this$$route$meta === void 0 ? void 0 : _this$$route$meta.sidebarItemKey;
      var keys = new Set();
      var _findActiveBranch = function findActiveBranch(items) {
        var parents = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
        var _iterator = _createForOfIteratorHelper(items),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var _item$items2;
            var item = _step.value;
            if (!item.link) {
              var _item$items;
              if ((_item$items = item.items) !== null && _item$items !== void 0 && _item$items.length) {
                var childMatch = _findActiveBranch(item.items, [].concat(_toConsumableArray(parents), [item.key]));
                if (childMatch) return true;
              }
              continue;
            }

            // Extract path and hash from item.link if it contains a hash
            var linkParts = item.link.split("#");
            var linkPath = linkParts[0];
            var linkHash = linkParts[1] ? "#" + linkParts[1] : null;

            // Compare path without query parameters for exact and prefix matches
            var pathMatches = false;
            if (linkHash) {
              // For hash-based routes (e.g., /projects/list#all)
              // Check if path matches and hash matches (ignoring query params)
              var currentHash = currentFullPath.includes("#") ? "#" + currentFullPath.split("#")[1] : null;
              pathMatches = currentPath === linkPath && currentHash === linkHash;
            } else {
              // For regular routes without hash
              pathMatches = currentPath === item.link || currentPath.startsWith(item.link + "/");
            }
            var keyMatches = currentSidebarKey && item.key === currentSidebarKey;
            if (pathMatches || keyMatches) {
              parents.forEach(function (key) {
                return keys.add(key);
              });
              if (item.key) keys.add(item.key);
              return true;
            }
            if ((_item$items2 = item.items) !== null && _item$items2 !== void 0 && _item$items2.length) {
              var _childMatch = _findActiveBranch(item.items, [].concat(_toConsumableArray(parents), [item.key]));
              if (_childMatch) return true;
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
        return false;
      };
      _findActiveBranch(this.menuItems);
      return keys;
    }
  }),
  methods: {
    logout: function logout() {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _context2.n = 1;
              return _this2.$store.dispatch("session/logMeOut").then(function () {
                _this2.$router.push("/login");
              });
            case 1:
              return _context2.a(2);
          }
        }, _callee2);
      }))();
    },
    toggleMenu: function toggleMenu(menu) {
      if (this.openedMenus.includes(menu)) {
        this.openedMenus.splice(this.openedMenus.indexOf(menu), 1);
      } else {
        this.openedMenus.push(menu);
      }
    }
  }
};